import { unite as libelleUnite } from "@/utils/format";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "./assets/theme.css";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

import { installerSurveillance, installerHorsLigne } from "./surveillance/erreurs";
import { surveillerInstallation } from "./pwa";
import { demarrerHorsLigne } from "./horsLigne";

const app = createApp(App);
app.config.globalProperties.$u = libelleUnite;
installerSurveillance(app);
installerHorsLigne();
surveillerInstallation(); // bouton « Installer l'application »
demarrerHorsLigne(store); // ventes faites sans internet : envoi au retour de la connexion
app.use(store).use(router).component("Multiselect", Multiselect).mount("#app");
